import { render } from "./ProblemDocument.vue?vue&type=template&id=45994ea8&ts=true"
import script from "./ProblemDocument.vue?vue&type=script&lang=ts"
export * from "./ProblemDocument.vue?vue&type=script&lang=ts"

import "./ProblemDocument.vue?vue&type=style&index=0&id=45994ea8&lang=scss"

import exportComponent from "/Users/zhouyuan/work/project/cargpsweb-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__